import getConfig from 'next/config'

import { DataLayer } from '@grandvisionhq/analytics'
import { Orders as OrdersApi, Stores as StoresApi } from '@grandvisionhq/api-client'
import { getToken, State as AuthState } from '@grandvisionhq/auth'

const apiUrls = getConfig()?.publicRuntimeConfig?.grandvision?.endpoints || {}

export const getStore = (storeId?: string) => {
  if (storeId) {
    return StoresApi.getDetailsByCode(apiUrls.stores, { code: storeId })
  }
  return null
}

export const getOrdersInfo = async (userId?: string) => {
  let orders
  let hasPrescriptionOrders = false
  if (userId) {
    const accessToken = await getToken()
    orders = await OrdersApi.list(apiUrls.orders, accessToken, {
      customerId: userId,
      limit: 10,
      offset: 0,
    })

    // check if any order contains a prescription product
    hasPrescriptionOrders = orders?.orders?.some((order) =>
      order.lineItems.some((lineItem) => {
        return (
          OrdersApi.isDetailContactLenses(lineItem.product) ||
          OrdersApi.isDetailContactLensBundles(lineItem.product) ||
          OrdersApi.isPrescriptionGlasses(lineItem.product)
        )
      })
    )
  }

  return {
    hasAnyOrder: orders?.total > 0,
    hasPrescriptionOrders,
  }
}

export const pushBookAppointmentDataLayer = async (
  loggedInState: AuthState.AuthState | AuthState.AuthStateLoading,
  userId?: string,
  storeId?: string
) => {
  if (typeof window !== 'undefined' && loggedInState !== 'loading') {
    const [store, ordersInfo] = await Promise.all([getStore(storeId), getOrdersInfo(userId)])

    const isUserLoggedIn = loggedInState === 'logged-in'

    DataLayer.pushEvent({
      event: 'pageview',
      containsAppointmentInfo: 'TRUE',
      appointmentLocation: store?.postalCode,
      appointmentStoreName: store?.storeName,
      appointmentForCustomer: ordersInfo.hasAnyOrder ? 'TRUE' : 'FALSE',
      appointmentWithPrescription: ordersInfo.hasPrescriptionOrders ? 'TRUE' : 'FALSE',
      containsUserInfo: isUserLoggedIn ? 'TRUE' : 'FALSE',
    })
  }
}
